// SERVICE WORKER DISABLED FOR LOCALHOST DEVELOPMENT
// 
// The service worker causes issues when running on localhost:
// 1. It intercepts fetch requests and doesn't properly forward custom headers
// 2. Our localhost setup uses X-Session-Ref header (added in bootstrap.tsx) instead of cookies
// 3. The service worker blocks this header from being sent to the API
// 4. This causes authentication to fail even with a valid session token
//
// The service worker works fine in deployed environments where cookie-based auth is used.
// For production deployment, uncomment the service worker code below.
//
// import { registerServiceWorker } from '@ps-refarch-ux/mfe-utils';
//
// console.log('Loading service-worker.js');
// registerServiceWorker('service-worker.js')
//   .then(() => navigator.serviceWorker.ready)
//   .then(() => {
//     import('./bootstrap');
//   })
//   .catch((error) => {
//     console.warn('Service worker registration failed, continuing without caching:', error);
//     import('./bootstrap');
//   });

// Bootstrap directly without service worker (for localhost development)
console.log('Loading app without service worker...');
import('./bootstrap');

export {}; // To make it a module under --isolatedModules
